import React, { useState } from 'react';
import {
	Card,
	Dropdown,
	DropdownItem,
	DropdownToggle,
	DropdownMenu,
	Modal,
	ModalBody,
	Button,
	Badge,
	Spinner,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import EditMemora from '../components/Modals/EditMemora';

import Avatar from 'react-avatar';
import moment from 'moment';
import MemoraLogo from '../assets/imgs/memora_logo_small.png';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { deleteMemoir } from '../redux/actions/memoir.action';
import { customAlert } from '../redux/actions/alertActions';
function MemoirCard(props) {
	let { index, mem, height, showMenu, linkable, settings } = props;
	const [deleteModal, setDeleteModal] = useState(false);
	const [dropOpen, setDropOpen] = useState(false);
	const [memId, setMemId] = useState('');
	const { uid } = useSelector(state => state.auth);
	const { loading } = useSelector(state => state.memoir);
	const dispatch = useDispatch();
	const deleteToggle = () => {
		setDeleteModal(!deleteModal);
	};
	const toggleDropDown = () => {
		setDropOpen(!dropOpen);
	};
	const [modals, setModals] = useState({
		category: false,
		createTimeline: false,
		addMedia: false,
	});

	const [memoirData, setMemoirData] = useState({
		memoir_title: '',
		title: '',
		first_name: '',
		last_name: '',
		introduction: '',
		relationship: '',
		date_of_birth: '',
		date_of_death: '',
		home_town: '',
		location: '',
		start_date: '',
		end_date: '',
		isMemoirPublic: false,
		isHomeTownPublic: false,
		isDOBPublic: false,
		isHideFromSearchEngines: false,
		isIntroductionVisible: false,
	});
	const [profileType, setProfileType] = useState('person');
	const [selectedCat, setSelectedCat] = useState('');
	const toggleModalEdit = name => {
		let newModal = JSON.parse(JSON.stringify(modals));
		for (let modal of Object.keys(newModal)) {
			if (modal != name) newModal[modal] = false;
		}
		newModal[name] = !newModal[name];
		setModals(newModal);
		setSelectedCat(mem.category);
	};
	const getRole = u_id => {
		let roleCheck = mem.collaborators.find(collab => collab.id == u_id);
		if (roleCheck) {
			return roleCheck.role;
		} else {
			return 'owner';
		}
	};
	return (
		<>
			{/* Category Modal */}
			<EditMemora
				isOpen={modals}
				toggleModalEdit={toggleModalEdit}
				memoirData={memoirData}
				setMemoirData={setMemoirData}
				profileType={profileType}
				setProfileType={setProfileType}
				selectedCat={selectedCat}
				setSelectedCat={setSelectedCat}
				mem={mem}
			/>
			{/* Delete Modal */}
			<Modal isOpen={deleteModal} centered toggle={deleteToggle}>
				<ModalBody>
					<div className='text-center'>
						<i
							className='far fa-times-circle text-danger'
							style={{ fontSize: 70 }}
						></i>
						<br />
						<br />
						<span className='mt-5' style={{ fontSize: 30 }}>
							Are you sure?
						</span>
						<br />
						<br />
						<span className='mt-5' style={{ fontSize: 16 }}>
							Do you really want to remove this Memoir? This
							process cannot be undone.
						</span>
						<br />
						<br />
						<br />
						<Button color='secondary' onClick={deleteToggle}>
							Cancel
						</Button>{' '}
						<Button
							color='danger'
							disabled={loading}
							onClick={async e => {
								e.preventDefault();
								if (memId != '') {
									await dispatch(deleteMemoir(memId));
									deleteToggle();
								} else {
									dispatch(
										customAlert(
											true,
											'Please Select Memoir you want to delete!'
										)
									);
									setTimeout(() => {
										dispatch(customAlert(false, ''));
									}, 150);
									// toast.warning(
									// 	'Please Select Memoir you want to delete!'
									// );
								}
							}}
						>
							{loading ? <Spinner size='sm' /> : 'Delete'}
						</Button>
					</div>
				</ModalBody>
			</Modal>
			<Card key={index}>
				<Link to={linkable && `/dashboard/${mem.id}/timeline`}>

					<div
						className={`position-relative ${
							mem && mem.cover_image
								? 'memoir-cover-image'
								: 'memoir-default-cover'
						}`}
						style={{
							backgroundImage: `url(${mem && mem.cover_image})`,
							height: height,
						}}
					>
						{/* {mem.cover_image && (
							<img
								src={mem.cover_image}
								alt=''
								// className='img-fluid'
								// width='100%'
								// height='100%'
							/>
						)} */}
						<div
							className='position-absolute'
							style={{
								top: '100%',
								left: '50%',
								transform: 'translate(-50%,-50%)',
							}}
						>
							{mem.display_image != '' ? (
								<Avatar
									round={true}
									size='64px'
									className='memoir_display_img'
									src={mem.display_image}
								/>
							) : (
								<Avatar
									round={true}
									size='64px'
									className='memoir_no_display_img'
									src={MemoraLogo}
								/>
							)}
						</div>
					</div>

					<div className='text-center text-dark'>
						<h5 className='font-weight-bold mt-4 pt-3'>
							{/* {mem.first_name} {mem.last_name} */}
							{mem.memoir_title}
						</h5>
						{/* <p className="f-14">{mem.introduction}</p> */}
						<p className='mt-2'>
							{mem.introduction.length > 20
								? mem.introduction.slice(0, 25) + '....'
								: mem.introduction}
						</p>
						{mem.category && <p className='mt-2'>{mem.category}</p>}
					</div>
				</Link>
				<div className='card-f f-14 py-1 d-flex justify-content-center mt-1  position-relative'>
					{settings && (
						<div className='mx-2'>
							<Badge className='text-left'>
								{uid == mem.user_id ? 'Owner' : getRole(uid)}
							</Badge>
						</div>
					)}

					<span className='text-end'>
						{mem &&
							mem.created_at &&
							moment
								.unix(mem.created_at.seconds)
								.format('DD/MM/YYYY')}
					</span>

					<div className={`${showMenu ? 'd-block' : 'd-none'}`}>
						<Dropdown
							toggle={e => {
								e.preventDefault();
								toggleDropDown();
							}}
							// isOpen={dropOpen != -1 && dropOpen == index ? true : false}
							isOpen={dropOpen}
							direction='left'
							className='position-absolute'
							style={{
								top: '50%',
								right: '10px',
								transform: 'translateY(-50%)',
							}}
						>
							<DropdownToggle
								className='bg-transparent'
								color='black'
							>
								<i className={`fa fa-ellipsis-v pointer`}></i>
							</DropdownToggle>
							<DropdownMenu style={{ minWidth: 0 }}>
								<DropdownItem
									style={{ width: 'auto' }}
									onClick={() => {
										toggleModalEdit(
											'createTimeline',
											mem.id
										);
										if (
											mem.category == 'Myself' ||
											mem.category == 'Someone else'
										) {
											setProfileType('person');
											setMemoirData({
												memoir_title: mem.memoir_title
													? mem.memoir_title
													: '',
												title: mem.title
													? mem.title
													: '',
												first_name: mem.first_name
													? mem.first_name
													: '',
												last_name: mem.last_name
													? mem.last_name
													: '',
												introduction: mem.introduction
													? mem.introduction
													: '',
												relationship: mem.relationship
													? mem.relationship
													: '',
												date_of_birth: mem.date_of_birth
													? mem.date_of_birth
													: '',
												date_of_death: mem.date_of_death
													? mem.date_of_death
													: '',
												home_town: mem.home_town
													? mem.home_town
													: '',
												isMemoirPublic:
													mem.isMemoirPublic
														? mem.isMemoirPublic
														: '',
												isHomeTownPublic:
													mem.isHomeTownPublic
														? mem.isHomeTownPublic
														: '',
												isDOBPublic: mem.isDOBPublic
													? mem.isDOBPublic
													: '',
												isHideFromSearchEngines:
													mem.isHideFromSearchEngines
														? mem.isHideFromSearchEngines
														: '',
												isIntroductionVisible:
													mem.isIntroductionVisible
														? mem.isIntroductionVisible
														: '',
											});
										} else {
											setProfileType('else');
											setMemoirData({
												else_category: '',
												end_date: mem.end_date
													? mem.end_date
													: '',
												introduction: mem.introduction
													? mem.introduction
													: '',
												location: mem.location
													? mem.location
													: '',
												memoir_title: mem.memoir_title
													? mem.memoir_title
													: '',
												start_date: mem.start_date
													? mem.start_date
													: '',
												isMemoirPublic:
													mem.isMemoirPublic
														? mem.isMemoirPublic
														: '',
												isHomeTownPublic:
													mem.isHomeTownPublic
														? mem.isHomeTownPublic
														: '',
												isDOBPublic: mem.isDOBPublic
													? mem.isDOBPublic
													: '',
												isHideFromSearchEngines:
													mem.isHideFromSearchEngines
														? mem.isHideFromSearchEngines
														: '',
												isIntroductionVisible:
													mem.isIntroductionVisible
														? mem.isIntroductionVisible
														: '',
											});
										}
									}}
								>
									<i className='fa fa-pencil-alt pointer'></i>
								</DropdownItem>
								<DropdownItem
									style={{ width: 'auto' }}
									onClick={() => {
										setMemId(mem.id);
										deleteToggle();
									}}
									disabled={getRole(uid) == 'contributer'}
								>
									<i className='fa fa-trash pointer'></i>
								</DropdownItem>
							</DropdownMenu>
						</Dropdown>
					</div>
					{/* <i
                          className="far fa-trash-alt position-absolute"
                          style={{
                            top: '50%',
                            right: '10px',
                            transform: 'translateY(-50%)',
                          }}
                        ></i> */}
				</div>
			</Card>
		</>
	);
}

export default MemoirCard;
